import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import DatePickerInput from "../../controls/DatePickerInput";
import SelectMenu from "../../controls/SelectMenu";
import { formatDate } from "../../../shared/utility";
import { useState } from "react";

export default function OrderItemsTable(props) {
  const {
    loading,
    values,
    askEditOrderItem,
    askDeleteOrderItem,
    onItemEditComplete,
    employeeOptions,
  } = props;

  const [selectedEmployeesByRow, setSelectedEmployeesByRow] = useState({});

  function employeeEditor(options) {
    return (
      <SelectMenu
        handleInputChange={(e) => {
          options.editorCallback(e.target.value);
          setSelectedEmployeesByRow({
            ...selectedEmployeesByRow,
            [options.rowData.id]: e.target.value,
          });
        }}
        name="employee"
        options={employeeOptions}
        value={
          selectedEmployeesByRow[options.rowData.id]
            ? selectedEmployeesByRow[options.rowData.id]
            : options.rowData.assigned_employees
        }
        showLabel={true}
        isMulti={true}
        menuPortalTarget={document.body}
      />
    );
  }

  const serviceAndMaterials = (rowData) => {
    const material = rowData.service_type === 0 ? ` (${rowData.item})` : null;
    return (
      <p>
        {rowData.service_name}
        {material}
      </p>
    );
  };

  const quantityBody = (rowData) => {
    return <p>{rowData.quantity}</p>;
  };

  const dateEditor = (options) => {
    const val = options.value;
    return (
      <DatePickerInput
        name={"work_date"}
        onChange={(e) => {
          if (e && e.target) {
            options.editorCallback(e.target.value);
          } else {
            options.editorCallback(null);
          }
        }}
        value={val}
        labelOn={false}
      />
    );
  };

  const dateBody = (rowData) => {
    return <p>{formatDate(rowData.work_date)}</p>;
  };

  const employeeBody = (rowData) => {
    if (
      !rowData.assigned_employees ||
      rowData.assigned_employees.length === 0
    ) {
      return <p>-</p>;
    }

    // Join all user names with commas
    const names = rowData.assigned_employees.map((emp) => emp.label).join(", ");
    return <p>{names}</p>;
  };

  const moreDetailsBody = (rowData) => {
    var moreDetails = null;
    if (rowData.service_type === 0) {
      moreDetails = rowData.item;
    } else if (rowData.selected_option) {
      moreDetails = rowData.selected_option.name;
    }

    return <p>{moreDetails}</p>;
  };

  const allowEdit = (rowData) => {
    return rowData.name !== "Blue Band";
  };

  const massItemActionTemplate = (rowData) => {
    return (
      <div className="flex">
        <button
          onClick={() => {
            askEditOrderItem(rowData);
          }}
          className="ml-2 rounded-md bg-yellow-500 px-1.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-yellow-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-500"
        >
          Edit
        </button>
        <button
          onClick={() => {
            askDeleteOrderItem(rowData);
          }}
          className="ml-2 rounded-md bg-red-600 px-1.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
        >
          Delete
        </button>
      </div>
    );
  };

  return (
    <div className="">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          {loading ? (
            <div>
              <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                <div className="animate-pulse flex space-x-4">Loading</div>
              </div>
            </div>
          ) : (
            <div className="overflow-hidden">
              <DataTable
                value={values.items}
                dataKey="id"
                editMode="row"
                onRowEditComplete={(e) => {
                  setSelectedEmployeesByRow([]);
                  onItemEditComplete(e.newData);
                }}
                tableClassName="min-w-full bg-white divide-y divide-gray-300"
                cellClassName="p-2 bg-white border-1-bottom-gray text-sm"
              >
                <Column
                  header="Service"
                  body={serviceAndMaterials}
                  style={{ width: "30%" }}
                />

                <Column
                  header="Details"
                  field="quantity"
                  style={{ textAlign: "right" }}
                  body={quantityBody}
                />

                <Column
                  header="More Details"
                  body={moreDetailsBody}
                  style={{ width: "20%" }}
                />

                <Column
                  header="Employee"
                  body={employeeBody}
                  editor={(options) => employeeEditor(options)}
                  field="assigned_employees"
                  style={{ width: "30%" }}
                />

                <Column
                  field="work_date"
                  header="Date"
                  editor={(options) => dateEditor(options)}
                  body={dateBody}
                  style={{ width: "20%" }}
                />

                <Column
                  rowEditor={allowEdit}
                  headerStyle={{ width: "5%", minWidth: "8rem" }}
                  bodyStyle={{ textAlign: "center" }}
                />

                <Column
                  header=""
                  body={massItemActionTemplate}
                  style={{ width: "6%" }}
                />
              </DataTable>
            </div>
          )}
          {/* <div className="w-full text-right mt-4">
            <p className="font-bold">
              Subtotal: {convertToCurrencyFormat(values.subtotal_dollar_amount)}
            </p>
            <p className="font-bold">
              Taxes: {convertToCurrencyFormat(values.tax_amount)}
            </p>
            <p className="font-bold">
              Total: {convertToCurrencyFormat(values.total_dollar_amount)}
            </p>
          </div> 
          
          */}
        </div>
      </div>
    </div>
  );
}
